export default "__VITE_ASSET__B1lS8mWC__"